export class MessageParser {
  constructor(actionProvider) {
    this.actionProvider = actionProvider;
  }

  parse(message) {
    const trimmedMessage = message.trim();
    //console.log(`Passing raw message to handler: "${trimmedMessage}"`);
    this.actionProvider.handleRecognizedIdLookup(trimmedMessage);
  }
}
